import { FC, useState } from 'react';
import { IconButton, IconName } from '@optimus-web/core';
import { FloatingPanel } from '@mews/b2b-ui';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { BookingEngineLinkWrapper } from '../../BookingEngineLink/BookingEngineLinkWrapper';

interface BookingEngineButtonProps {
    availabilityBlock: AvailabilityBlock;
}

export const BookingEngineButton: FC<BookingEngineButtonProps> = ({ availabilityBlock }) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <IconButton size="small" icon={IconName.CustomLink} onClick={() => setOpen(true)} type="submit" />
            <FloatingPanel
                active={open}
                size="small"
                onClose={() => setOpen(false)}
                title={<LocalizedText textKey={TextKey.BookingEngineLink} />}
            >
                <BookingEngineLinkWrapper
                    availabilityBlockId={availabilityBlock.id}
                    serviceId={availabilityBlock.serviceId}
                    startUtc={availabilityBlock.startUtc}
                    endUtc={availabilityBlock.endUtc}
                />
            </FloatingPanel>
        </>
    );
};
